export function appendHashIfNotExists(color) {
  if (!color) {
    return ''
  }

  if (!color?.startsWith?.('#')) {
    return `#${color}`
  }

  return color
}
